import { tr } from "../../i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../../auth/AuthContext";
import { Card, EmptyState, fmtDateTime } from "../../components/portal";
export default function Dashboard() {
  const {
    lang = "en"
  } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/client/overview").then(r => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return <p className="text-sm text-esaia-subtle">{tr("Loading...")}</p>;
  const stats = [{
    label: "Active Assessments",
    value: data.active_assessments,
    to: `/${lang}/portal/assessments`
  }, {
    label: "Completed Assessments",
    value: data.completed_assessments,
    to: `/${lang}/portal/assessments`
  }, {
    label: "Certificates",
    value: data.certificates,
    to: `/${lang}/portal/certificates`
  }];
  return <div className="mx-auto max-w-5xl" data-testid="client-dashboard">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-esaia-blue">{tr("Client Portal")}</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-esaia-ink sm:text-3xl">{tr("Welcome,")}{" "}{data.first_name}
      </h1>
      <p className="mt-1 text-sm text-esaia-muted">{data.company}</p>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {stats.map(s => <Link key={s.label} to={s.to} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`} className="group border border-esaia-line bg-white p-6 transition-all hover:border-esaia-blue/50 hover:shadow-md">
            <p className="font-serif text-4xl font-light text-esaia-blue">{s.value}</p>
            <p className="mt-2 text-sm font-medium text-esaia-ink">{tr(s.label)}</p>
          </Link>)}
      </div>

      <div className="mt-8">
        <Card title={tr("Latest Updates")} testid="latest-updates">
          {data.latest_updates.length === 0 ? <p className="text-sm text-esaia-subtle">{tr("No updates yet.")}</p> : <ul className="divide-y divide-esaia-line">
              {data.latest_updates.map((u, i) => <li key={i} className="flex items-center justify-between gap-4 py-3">
                  <span className="text-sm text-esaia-ink">{u.type === "certificate" ? `${tr("Certificate")} ${u.ref} (${tr(u.status)})` : `${tr("Management report")}: ${u.ref}`}</span>
                  <span className="shrink-0 font-mono text-[11px] text-esaia-subtle">{fmtDateTime(u.date)}</span>
                </li>)}
            </ul>}
        </Card>
      </div>

      <Link to={`/${lang}/portal/request-service`} data-testid="dashboard-request-service" className="group mt-8 inline-flex items-center gap-2 bg-esaia-blue px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark">{tr("Request a Service")}{" "}<ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
      </Link>
    </div>;
}
export { EmptyState };
